<template>
  <span>{{ value }}<span class="discount">{{ discount }}</span> </span>
</template>

<script>
export default {
  name: 'PdrGrossValueRenderer',
  data () {
    return {
      value: '',
      discount: ''
    }
  },
  created () {
    const value = this.params.data.valorBruto
    var result = ''
    if (value) {
      result += '( ' + value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2})
      result += (this.params.data.reducao1 ? ' x ' + ((100 - this.params.data.reducao1) / 100).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}) : '')
      result += (this.params.data.reducao2 ? ' x ' + ((100 - this.params.data.reducao2) / 100).toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}) : '')
      result += ' )'
      result += (this.params.data.adicional ? ' + ' + this.params.data.adicional + '%' : '')
    }

    this.value = result
    this.discount = (this.params.data.desconto ? ' - ' + this.params.data.desconto.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}) : '')
  }
}
</script>

<style scoped>
span.discount {
  font-weight: bold;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/PdrGrossValueRenderer.vue